import { forwardRef } from 'react';

// eslint-disable-next-line prefer-arrow-callback
const LinkInner = forwardRef(function LinkInner(props, ref) {
  return <a ref={ref} {...props} />;
});

export default LinkInner;
